import React from "react";
import dialog from '../../../common/utility/dialog';
import { Form, Tree, Divider, Select, PageHeader, Button, message, Icon } from "antd";
import SelectPlaceHolder from "../../../components/SelectPlaceHolder";

import accesoService from "../../../service/seguridad/accesoService";
import rolService from "../../../service/seguridad/rolService";

const { TreeNode } = Tree;
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.props.onSetBreadcrumb();
    this.state = {
      roles: [],
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      treeData: [],
      idRol: undefined
    };
  }

  onExpand = (expandedKeys) => {
    console.log("onExpand", expandedKeys);
    this.setState({
      expandedKeys,
      autoExpandParent: false,
    });
  };

  onCheck = (checkedKeys) => {
    console.log("onCheck", checkedKeys);
    this.setState({ checkedKeys });
  };

  onSelect = (selectedKeys, info) => {
    console.log("onSelect", info);
    this.setState({ selectedKeys });
  };

  renderTreeNodes = (data) =>
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode title={item.title} key={item.key} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode key={item.key} {...item} />;
    });

  handleChange = async (property, value) => {
    
    if (property === "idRol") {
      const data = await accesoService.obtenerPorIdRol(value);
      this.setState({
        idRol: value,
        checkedKeys: data.checkedKeys,
        treeData: data.treeData ? data.treeData : [],
      });
    }
  };

  handleSave = () => {
      
    var values = {
        idRol : this.state.idRol,
        IdsPagina : this.state.checkedKeys
    };
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
        var response;

        response = await accesoService.registrar(values);

        if (response.status === 200) {
            this.setState({ visible: false});
            message.success('Registrado correctamente.');
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            return;
        }

        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
    });
};

  async componentDidMount() {
    
    const roles = await rolService.listar();
    var data = await accesoService.obtenerPorIdRol(1);
    console.log(data);
    this.setState({
      roles: roles ? roles : [],
      checkedKeys: data.checkedKeys,
      treeData: data.treeData,
      idRol: 1
    });
  }

  render() {
    return (
      <div>
        <PageHeader
          title={<div><Icon type="container" />&nbsp;&nbsp;Accesos</div>}
          extra={[
            <div key="1">
              <Button icon="save" type="primary" ghost onClick={(option) => this.handleSave()}>
                Guardar
              </Button>
            </div>,
          ]}
        />
        <Divider />

        <div className="row mb-10">
          <div className="col-md-3">
            <Form.Item label="Rol">
              <Select
                showSearch
                labelInValue
                value={
                  this.state.idRol
                    ? { key: this.state.idRol }
                    : undefined
                }
                placeholder={<SelectPlaceHolder label="Filtrar por rol" />}
                onChange={(option) => this.handleChange("idRol", option.key)} //STATE PROPERTY
                optionFilterProp="children"
              >
                {this.state.roles.map((
                  item //STATE DATA
                ) => (
                  <Select.Option value={item.id} key={item.id}>
                    {item.nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>

        <Tree
          checkable
          onExpand={this.onExpand}
          expandedKeys={this.state.expandedKeys}
          autoExpandParent={this.state.autoExpandParent}
          onCheck={this.onCheck}
          checkedKeys={this.state.checkedKeys}
          onSelect={this.onSelect}
          selectedKeys={this.state.selectedKeys}
          // disabled={this.state.idRol === 1}
        >
          {this.renderTreeNodes(this.state.treeData)}
        </Tree>
      </div>
    );
  }
}

export default Form.create()(Index);
